import axiosFetchBase from '../axiosFetchBase';
import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';

export const externalPartnersApi = createApi({
  reducerPath: 'externalPartnersApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getExternalPartners: builder.query({
      query: (approvedOnly) => ({
        url: urls.externalPartners(approvedOnly),
        method: 'GET',
      }),
    }),
    getExternalPartnerDetail: builder.query({
      query: (id) => ({
        url: urls.externalPartnerDetail(id),
        method: 'GET',
      }),
    }),
    approveExternalPartner: builder.mutation({
      query: (id) => ({
        url: urls.externalPartnerApprove(id),
        method: 'PUT',
      }),
    }),
    activateExternalPartner: builder.mutation({
      query: (id) => ({
        url: urls.externaPartnerActivate(id),
        method: 'PUT',
      }),
    }),
    deactivateExternalPartner: builder.mutation({
      query: (id) => ({
        url: urls.externalPartnerDeactivate(id),
        method: 'PUT',
      }),
    }),
    saveExternalPartner: builder.mutation({
      query(req) {
        if (req.body.id) {
          return {
            url: urls.externalPartnerDetail(req.body.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: `${urls.externalPartnerCreate}`,
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),
    deleteExternalPartner: builder.mutation({
      query: (id) => ({
        url: urls.externalPartnerDelete(id),
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetExternalPartnersQuery,
  useGetExternalPartnerDetailQuery,
  useApproveExternalPartnerMutation,
  useActivateExternalPartnerMutation,
  useDeactivateExternalPartnerMutation,
  useSaveExternalPartnerMutation,
  useDeleteExternalPartnerMutation,
} = externalPartnersApi;
